import { fbAppId } from '~/constants/site';
import { HOST_URL, TWITTER_USERNAME } from '~/constants/config';
import { getArticleUrl } from '~/modules/common/utils/routingUtils';
import { getImageUrl } from '~/modules/common/utils/imageUtils';
import { articleDescription } from '~/modules/article/utils/articleUtils';

const getHtml = (article) => {
  const rurl = article.redirectUrl;
  const html = `
    <html>
      <head>
        <noscript><meta http-equiv="refresh" content="0;URL=${rurl}"></noscript>
        <script type="text/javascript">location.replace("${rurl}")</script>
        <meta property="fb:app_id" content="${fbAppId}">
        <meta property="og:title" content="${article.title.replace(/"/g, '&quot;')}">
        <meta property="og:url" content="${HOST_URL + getArticleUrl({ article })}">
        <meta name="og:description" content="${articleDescription(article)}">
        <meta property="og:image" content="${getImageUrl(article.image, { high: true })}">
        <meta property="og:type" content="article">
        <meta name="twitter:site" content="${TWITTER_USERNAME}">
        <meta name="twitter:url" content="${HOST_URL + getArticleUrl({ article })}">
        <meta name="twitter:description" content="${articleDescription(article)}">
        <meta name="twitter:title" content="${article.title.replace(/"/g, '&quot;')}">
      </head>
      <body/>
    </html>`;
  return html;
};

export default ({ res }, inject) => {
  inject('redirect', (article) => {
    const htmlResult = getHtml(article);
    res
      .writeHead(200, {
        'Content-Length': Buffer.byteLength(htmlResult),
        'Content-Type': 'text/html; charset=utf-8',
      })
      .end(htmlResult);
  });
};
